import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch } from "react-redux";
import { changeLanguage } from "../../redux/languageDucks";
// Components
import {
  SelectLng,
  LngAndSelector,
  ChangeLngButton,
  LngSeparator,
  ShowLanguages,
  CurrentLngButton,
  CurrentLngText,
  ArrowImg,
} from "./styles";
// Assets
import RightArrow from "../../assets/ico_arrow_right.svg";
import LeftArrow from "../../assets/ico_arrow_left.svg";

const languages = [
  {
    type: "es",
  },
  {
    type: "en",
  },
  {
    type: "ca",
  },
  {
    type: "ua",
  },
];

const Translations = () => {
  const [showLanguages, setShowLanguages] = useState(false);
  const [, i18n] = useTranslation("global");
  const dispatch = useDispatch();

  const handleShowLanguages = () => setShowLanguages(!showLanguages);

  const handleChangeLng = (e, lng) => {
    e.preventDefault();
    dispatch(changeLanguage(lng.type));
  };

  const renderLanguages = () => (
    <SelectLng>
      {languages.map((lng, i, languagesArray) => {
        const isActive = lng.type === i18n.language ? true : false;

        return (
          <LngAndSelector key={i}>
            <ChangeLngButton active={isActive} onClick={(e) => handleChangeLng(e, lng)}>
              {lng.type}
            </ChangeLngButton>
            {i !== languagesArray.length - 1 && <LngSeparator />}
          </LngAndSelector>
        );
      })}
      <ShowLanguages onClick={handleShowLanguages}>
        <ArrowImg src={RightArrow} alt="arrow-right" />
      </ShowLanguages>
    </SelectLng>
  );

  const renderCurrentLanguage = () => (
    <CurrentLngButton onClick={handleShowLanguages}>
      <CurrentLngText>{i18n.language}</CurrentLngText>
      <ArrowImg src={LeftArrow} alt="arrow-left" />
    </CurrentLngButton>
  );

  return showLanguages ? renderLanguages() : renderCurrentLanguage();
};

export default Translations;
